
import { Component, Vue, Watch } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import {
  getSmsAccountList,
  deleteSmsAccount,
  refreshBalance
} from '@/api/product/smsManage'
import addSmsAccount from '@/views/product/smsComponent/addSmsAccount.vue'
import editSmsAccount from '@/views/product/smsComponent/editSmsAccount.vue'
import smsBalance from '@/views/product/smsComponent/smsBalance.vue'
import balanceList from './smsComponent/merchantBalance.vue'
import smsLog from './smsComponent/smsLog.vue'

@Component({
  name: 'smsManage',
  components: {
    addSmsAccount,
    editSmsAccount,
    smsBalance,
    balanceList,
    smsLog
  }
})
export default class extends Vue {
  get language() {
    return AppModule.language
  }
  private radio: string = 'sms_account'
  private listLoading: boolean = false
  private refreshLoading: boolean = false

  private queryForm: any = {
    account: '',
    merchant_no: '',
    sms_id: '',
  }

  private total = 0
  private smsList: any = []
  private logList: any = []
  private editInfo: any = {}

  // 短信账户操作
  private openAddAccountVisible: boolean = false
  private openEditAccountVisible: boolean = false
  private openAddAccount() {
    this.openAddAccountVisible = true
  }
  private closeAddAccount() {
    this.openAddAccountVisible = false
    this.openEditAccountVisible = false
    this.getAccountList()
  }

  private editAccount(row: any) {
    this.editInfo = row
    this.openEditAccountVisible = true
  }
  private delAccount(row: any) {
    if (this.language === 'en') {
      this.$confirm('Are you sure to delete it?', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        type: 'warning',
        callback: action => {
          if (action === 'confirm') {
            deleteSmsAccount({ id: row.id }).then(() => {
              this.$message({
                type: 'success',
                message: 'Delete Successfully'
              })
              this.getAccountList()
            })
          }
        }
      })
    }
    if (this.language === 'zh_cn') {
      this.$confirm('确定要删除吗？ ', {
        confirmButtonText: '是的 ',
        cancelButtonText: '取消',
        type: 'warning',
        callback: action => {
          if (action === 'confirm') {
            deleteSmsAccount({ id: row.id }).then(() => {
              this.$message({
                type: 'success',
                message: '成功删除'
              })
              this.getAccountList()
            })
          }
        }
      })
    }
    if (this.language === 'zh_tw') {
      this.$confirm('確定要刪除嗎？ ', {
        confirmButtonText: '是的 ',
        cancelButtonText: '取消',
        type: 'warning',
        callback: action => {
          if (action === 'confirm') {
            deleteSmsAccount({ id: row.id }).then(() => {
              this.$message({
                type: 'success',
                message: '成功删除'
              })
              this.getAccountList()
            })
          }
        }
      })
    }
  }

  private select() {
    this.getAccountList()
  }

  private reset() {
    this.queryForm.account = ''
    this.getAccountList()
  }

  private changeRadio(e) {
    this.queryForm.account = ''
    if (e === 'sms_account') {
      this.getAccountList()
    }
  }

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.getAccountList()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.getAccountList()
  }
  // 短信账户列表
  private getAccountList() {
    try {
      this.listLoading = true
      this.smsList = []
      let data: any = {
        account: this.queryForm.account,
        page_size: this.pagesize,
        page: this.currentPage
      }
      getSmsAccountList(data).then((res: any) => {
        this.total = res.count
        this.smsList = res.results
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  private async refreshBalance(index: any, row: any) {
    this.refreshLoading = true
    let data = {
      id: row.id,
      action: 'balance'
    }
    await refreshBalance(data).then((res: any) => {
      this.$set(row, 'balance', res.balance)
      this.refreshLoading = false
    })
  }

  private siteName = this.$store.state.app.enterprise.ssl_switch.site_name
  private systemName: any = 'Admin System'
  private sitelogo: any = this.$store.state.app.enterprise.ssl_switch.site_logo
  private systemLogo: any = ''
  mounted() {
    this.getAccountList()
    if (this.siteName && this.siteName !== '') {
      AppModule.SetSiteName(this.siteName)
      document.title = this.siteName + ' ' + this.$t(`route.operation`)
    } else {
      AppModule.SetSiteName(this.systemName)
      document.title = this.$t(`route.smsManage`) + '- Admin System'
    }
    if (this.sitelogo && this.sitelogo !== '') {
      AppModule.SetSiteLogo(this.sitelogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.sitelogo
      document.getElementsByTagName('head')[0].appendChild(link)
    } else {
      AppModule.SetSiteLogo(this.systemLogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.systemLogo
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  }
}
